export const defaultSettings = {
    appName: 'app-core',
    version: '0.0.0',
    certifiedVersion: '0.0.0',
    env: {},
    onUnauthorized: () => { },
    onLocaleChange: () => { },
    electron: {
        send: () => { },
        sendSync: () => null,
        on: () => { },
        off: () => { },
        invoke: async () => null,
        store: {
            get: async () => null,
            set: async () => { },
            delete: async () => { },
            custom: async () => null
        }
    }
};
//# sourceMappingURL=DefaultSettings.js.map